module.exports = __webpack_public_path__ + "static/3A841E_2_0-a544c690959b8926a5d759a84249b717.ttf";